module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-60x60-37898043c7355a9be8b28e10d9f0e0db.png";